// src/App.js

import React, { useState, useEffect } from 'react';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from './pages/LoginPage';

import AlertasPage from './pages/AlertasPage';

import DashboardLayout from './components/DashboardLayout';

import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';


const theme = createTheme({

  palette: {

    primary: { main: '#002347' },

    secondary: { main: '#F18824' },

  },

  typography: { fontFamily: 'Helvetica, Arial, sans-serif' },

});


// Usuario administrador de ejemplo

const ADMIN_USER = 'curielricardo@hotmail.com';


function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [userRole, setUserRole] = useState('user');

  const [loadingAuth, setLoadingAuth] = useState(true);


  useEffect(() => {

    const token = localStorage.getItem('accessToken');

    const email = localStorage.getItem('userEmail');

    if (token) {

      setIsAuthenticated(true);

      // Simulamos la asignación de rol

      if (email === ADMIN_USER) {

        setUserRole('admin');

      }

    }

    setLoadingAuth(false);

  }, []);


  const handleLogin = (email) => {

    setIsAuthenticated(true);

    if (email === ADMIN_USER) {

      setUserRole('admin');

    }

  };


  const handleLogout = () => {

    localStorage.removeItem('accessToken');

    localStorage.removeItem('userEmail');

    setIsAuthenticated(false);

    setUserRole('user');

  };


  if (loadingAuth) {

    return <div>Cargando...</div>;

  }

  

  return (

    <ThemeProvider theme={theme}>

      <CssBaseline />

      <BrowserRouter>

        <Routes>

          <Route path="/login" element={!isAuthenticated ? <LoginPage onLogin={handleLogin} /> : <Navigate to="/" />} />

          <Route path="/register" element={<div>Página de Registro</div>} />

          <Route path="/forgot-password" element={<div>Página de Olvidé mi Contraseña</div>} />


          <Route path="/" element={isAuthenticated ? <DashboardLayout userRole={userRole} onLogout={handleLogout} /> : <Navigate to="/login" />}>

            <Route path="alertas" element={<AlertasPage />} />

            <Route path="mapa" element={<div>Página de Mapa en Vivo</div>} />

            <Route path="reportes" element={<div>Página de Reportes</div>} />

            {/* Ruta de Admin protegida */}

            <Route path="admin" element={userRole === 'admin' ? <div>Página de Administración</div> : <Navigate to="/alertas" />} />

            <Route index element={<Navigate to="/alertas" replace />} />

          </Route>

        </Routes>

      </BrowserRouter>

    </ThemeProvider>

  );

}


export default App;
